// extracted by mini-css-extract-plugin
export default {"bolusTitle":"ActivityTitle_bolusTitle__GXFqg"};